import { render, staticRenderFns } from "./is_need_smt.vue?vue&type=template&id=abdeb780"
import script from "./is_need_smt.vue?vue&type=script&lang=js"
export * from "./is_need_smt.vue?vue&type=script&lang=js"
import style0 from "./is_need_smt.vue?vue&type=style&index=0&id=abdeb780&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports